import React from "react";

import styles from "../JobShiftPreStart/JobShiftPreStartView.module.css";
import JobShiftEmergencyPlanHeader from "./JobShiftEmergencyPlanHeader";
import EmergencyPlanDetails from "./sections/EmergencyPlanDetails";
import EmergencyPlanDocumentAuthorization from "./sections/EmergencyPlanDocumentAuthorization";
import EmergencyPlanAlarmCommunicationSection from "./sections/EmergencyPlanAlarmCommunicationSection";
import EmergencyPlanContactsSection from "./sections/EmergencyPlanContactsSection";
import EmergencyPlanResponseProcedureSection from "./sections/EmergencyPlanResponseProcedureSection";
import EmergencyPlanForeseeableRescueScenariosSection from "./sections/EmergencyPlanForeseeableRescueScenariosSection";
import EmergencyPlanMedicalConsiderationsSection from "./sections/EmergencyPlanMedicalConsiderationsSection";
import EmergencyPlanPostRescueNotificationSection from "./sections/EmergencyPlanPostRescueNotificationSection";
import EmergencyPlanRolesResponsibilitiesSection from "./sections/EmergencyPlanRolesResponsibilitiesSection";
import EmergencyPlanCustomSection from "./sections/EmergencyPlanCustomSection";
import EmergencyPlanRescueEquipmentSection from "./sections/EmergencyPlanRescueEquipmentSection";
import EmergencyPlanSignOffSection from "./sections/EmergencyPlanSignOffSection";

const getPlanList = (plans) => {
  if (plans && plans.emergency_plans && Array.isArray(plans.emergency_plans.plans)) {
    return plans.emergency_plans.plans;
  }
  if (plans && Array.isArray(plans.plans)) {
    return plans.plans;
  }
  if (plans && Array.isArray(plans.emergency_plans)) {
    return plans.emergency_plans;
  }
  if (plans && plans.document && Array.isArray(plans.document.plans)) {
    return plans.document.plans;
  }
  return [];
};

export { getPlanList };

const getOrderedEnabledSections = (plan) => {
  const sections = Array.isArray(plan && plan.sections) ? plan.sections : [];
  const sectionById = sections.reduce((result, section) => {
    if (section && section.id) result[section.id] = section;
    return result;
  }, {});

  return (Array.isArray(plan && plan.section_order) ? plan.section_order : [])
    .map((sectionId) => sectionById[sectionId])
    .filter((section) => section && section.data && section.data.toggle === 1);
};

export default function JobShiftEmergencyPlansDocument({ plans, sections, context }) {
  const planList = getPlanList(plans);

  return (
    <div className={styles.PreviewWrap}>
      <main>
        <div style={{ background: "transparent" }}>
          {planList.map((plan, index) => (
            <div
              key={plan.id || plan.plan_id || index}
              className={styles.PreviewDoc}
              style={{
                minHeight: "180px",
                marginBottom: index === planList.length - 1 ? 0 : "24px"
              }}
            >
              <JobShiftEmergencyPlanHeader plan={plan} index={index} sections={sections} context={context} />
              <EmergencyPlanDetails plan={plan} sections={sections} context={context} />
              <EmergencyPlanDocumentAuthorization plan={plan} sections={sections} />
              {getOrderedEnabledSections(plan).map((section, sectionIndex) => (
                section.id === "alarm_communication_emergency_access"
                  ? <EmergencyPlanAlarmCommunicationSection key={section.id} section={section} sectionNumber={sectionIndex + 3} />
                  : section.id === "emergency_contacts"
                    ? <EmergencyPlanContactsSection key={section.id} section={section} sectionNumber={sectionIndex + 3} />
                    : section.id === "emergency_response_procedure"
                      ? <EmergencyPlanResponseProcedureSection key={section.id} section={section} sectionNumber={sectionIndex + 3} />
                      : section.id === "foreseeable_rescue_scenarios"
                        ? <EmergencyPlanForeseeableRescueScenariosSection key={section.id} section={section} plan={plan} sectionNumber={sectionIndex + 3} />
                        : section.id === "medical_considerations"
                          ? <EmergencyPlanMedicalConsiderationsSection key={section.id} section={section} sectionNumber={sectionIndex + 3} />
                          : section.id === "post_rescue_notification"
                            ? <EmergencyPlanPostRescueNotificationSection key={section.id} section={section} sectionNumber={sectionIndex + 3} />
                            : section.id === "roles_responsibilities_competency"
                              ? <EmergencyPlanRolesResponsibilitiesSection key={section.id} section={section} sectionNumber={sectionIndex + 3} />
                              : section.type === "custom"
                                ? <EmergencyPlanCustomSection key={section.id} section={section} sectionNumber={sectionIndex + 3} />
                              : section.id === "rescue_equipment_staging"
                                ? <EmergencyPlanRescueEquipmentSection key={section.id} section={section} sectionNumber={sectionIndex + 3} />
                  : null
              ))}
              <EmergencyPlanSignOffSection
                staffSignOff={plans && plans.staff_sign_off}
                sectionNumber={getOrderedEnabledSections(plan).length + 3}
              />
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
